import { render, staticRenderFns } from "./claimReward.vue?vue&type=template&id=3624c836&scoped=true"
import script from "./claimReward.vue?vue&type=script&lang=js"
export * from "./claimReward.vue?vue&type=script&lang=js"
import style0 from "./claimReward.vue?vue&type=style&index=0&id=3624c836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624c836",
  null
  
)

export default component.exports